export default __webpack_public_path__ + "static/screenSecondSectionEn-c946bf8eeec4df3bcdcd847420fb06be.webp";